<template>
  <div id="event-live-curtain-button">
    <div class="pg-live__live_rehearsal__section_button_label">
      <div class="pg-live__live_live-section-donation-switch pg-live__live_live-section-curtain-switch">
        <input type="checkbox" id="can-use-curtain" class="pg-live__live_checkbox_function">
      </div>
      <div class="pg-live__live_rehearsal__label--thin pg-live__live_rehearsal__label--switch" style="white-space: unset;">フィラー表示(画面に蓋をして、音声も切ります)</div>
    </div>
  </div>
</template>

<script>
  import {db} from '../utils/firebase'
  import firebase from "firebase/app"
  import consts from '../utils/consts'

  export default {
    name: "EventLiveCurtainButton",
    props: {
      ttsid: { type: String, required: true },
    },
    data: () => ({
      isDispCurtain: false,
      firstdoc: "start",
    }),
    firestore() {
      const roomId = this.ttsid;
      const isDisp = this.isDispCurtain;

      (async () => {
        // roomの存在チェック
        const postRefParent = db.collection(consts.EVENT_LIVE_CURTAIN.PARENT_COLLECTION).doc(roomId)
        const postDocParent = await postRefParent.get()
        if (!postDocParent.exists) {
          // room生成
          await postRefParent.set({roomID: roomId},{merge: true})
        }
        // 幕の存在チェック
        const postRefChild = db.collection(consts.EVENT_LIVE_CURTAIN.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_CURTAIN.CHILD_COLLECTTION).doc(this.firstdoc)
        const postDocChild = await postRefChild.get()
        if (!postDocChild.exists) {
          const dispCurtain = db.collection(consts.EVENT_LIVE_CURTAIN.PARENT_COLLECTION).doc(roomId).collection(consts.EVENT_LIVE_CURTAIN.CHILD_COLLECTTION).doc(this.firstdoc)
          // 幕の生成
          await dispCurtain.set({isClosed: isDisp},{merge: false})
        }
      })()
      // 幕のOn/Off
      return {
        isDispCurtain: db.collection(consts.EVENT_LIVE_CURTAIN.PARENT_COLLECTION).doc(roomId).collection(consts.EVENT_LIVE_CURTAIN.CHILD_COLLECTTION).doc(this.firstdoc)
      }
    },
    mounted: function () {
      var _this = this
      $('.pg-live__live_live-section-curtain-switch').on('click', function(e) {
        _this.curtainDisp(e)
      });
    },
    methods: {
      // 幕の表示/非表示制御
      curtainDisp: function (e) {
        e.preventDefault()
        var modDisp = !this.isDispCurtain.isClosed
        var msg = ""
        if (modDisp) {
          msg = "フィラー(蓋絵)を視聴者に表示します。フィラーの表示中は視聴者にライブ配信が表示されなくなります。よろしいですか?"
        } else {
          msg = "フィラー(蓋絵)を表示しません。視聴者にライブ配信が表示されます。よろしいですか?"
        }
        if (!confirm(msg)) {
          return false
        }
        db.collection(consts.EVENT_LIVE_CURTAIN.PARENT_COLLECTION).doc(this.ttsid).collection(consts.EVENT_LIVE_CURTAIN.CHILD_COLLECTTION).get()
          .then(function(querySnapshot) {
            querySnapshot.forEach(function(doc) {
              doc.ref.update({
                isClosed: modDisp,
              })
            });
          })
      },
    },
    watch: {
      // コメントの取得
      isDispCurtain: function () {
        if(this.isDispCurtain.isClosed){
          $('#can-use-curtain').prop("checked", true)
        } else {
          $('#can-use-curtain').prop("checked", false)
        }
        $(window).scrollTop($(window).scrollTop() + 1) // これがないと一部端末でレンダリングされない
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import '../packs/application.css';

  #event-live-curtain-button {
    display: flex;

    @media (max-width: 445px) {
      display: block;
    }
  }

  .pg-live__live_live-section-curtain-switch {
  }

</style>
